import { useState } from "react";
import { toast } from "sonner";
import { Combine, Loader2, Trash2 } from "lucide-react";
import axios from "axios";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { useAuth } from "../context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LABELS = { vehicles: "المركبات", employees: "الموظفين", violations: "المخالفات", advances: "السلف", fuel: "سجلات الوقود", sales: "المبيعات", spare_parts: "قطع الغيار" };

export const BulkTools = ({ section, onDone, merge = false }) => {
  const [open, setOpen] = useState(false);
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState("");
  const { user } = useAuth();
  const label = LABELS[section];
  const delAll = async () => {
    setBusy("del");
    try {
      const r = (await axios.post(`${API}/bulk/${section}/delete-all`, { confirm: txt })).data;
      toast.success(`تم حذف ${r.deleted} من ${label}`);
      setOpen(false); setTxt(""); onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحذف"); } finally { setBusy(""); }
  };
  const doMerge = async () => {
    setBusy("merge");
    try {
      const d = (await axios.get(`${API}/bulk/${section}/duplicates`)).data;
      if (!d.groups) { toast.info("لا توجد سجلات مكررة ✅"); return; }
      const ex = d.examples.map((g) => g[0]).slice(0, 3).join("، ");
      if (!window.confirm(`وُجد ${d.extra} سجل مكرر في ${d.groups} مجموعة (مثل: ${ex}).\nسيتم دمج كل مجموعة في سجل واحد مع الحفاظ على العُهد وسجلات التسليم والبيانات المرتبطة. متابعة؟`)) return;
      const r = (await axios.post(`${API}/bulk/${section}/merge-duplicates`)).data;
      toast.success(`تم دمج ${r.merged} سجل مكرر ✅`);
      onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الدمج"); } finally { setBusy(""); }
  };
  if (user?.role !== "manager") return null;
  return (
    <>
      {merge && (
        <Button size="sm" variant="outline" onClick={doMerge} disabled={!!busy} data-testid={`bulk-merge-${section}`} className="gap-1.5 border-amber-200 text-amber-700 hover:bg-amber-50">
          {busy === "merge" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Combine className="h-4 w-4" />} دمج المكرر
        </Button>
      )}
      <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={`bulk-delete-all-${section}`} className="gap-1.5 border-rose-200 text-rose-700 hover:bg-rose-50">
        <Trash2 className="h-4 w-4" /> حذف الكل
      </Button>
      <Dialog open={open} onOpenChange={(v) => { if (!busy) { setOpen(v); setTxt(""); } }}>
        <DialogContent className="max-w-md" dir="rtl" data-testid={`bulk-delete-dialog-${section}`}>
          <DialogHeader className="text-right">
            <DialogTitle className="text-rose-700">حذف كل {label}</DialogTitle>
            <DialogDescription>سيُحذف كل {label} في الشركة نهائياً ولا يمكن التراجع. اكتب كلمة «حذف» للتأكيد.</DialogDescription>
          </DialogHeader>
          <Input value={txt} onChange={(e) => setTxt(e.target.value)} placeholder="حذف" data-testid={`bulk-delete-confirm-input-${section}`} />
          <Button onClick={delAll} disabled={txt.trim() !== "حذف" || !!busy} data-testid={`bulk-delete-confirm-${section}`} className="gap-1.5 bg-rose-600 hover:bg-rose-700">
            {busy === "del" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />} حذف الكل نهائياً
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
